import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import notificationScreens from "../../services/profileScreen/notificationScreens";
import { Paginator } from "primereact/paginator";
import "../../App.css";
import Loader from "../Loaders/Loader";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

const PatientSearch = (props) => {
  const { showbar, setshowBar, onSelect } = props;
  const [mobileNumber, setmobileNumber] = useState();
  const [firstName, setfirstName] = useState();
  const [lastName, setlastName] = useState();
  const [patientData, setpatientData] = useState("");
  const [patientId, setpatientId] = useState("");
  const [email, setemail] = useState("");
  const [dob, setdob] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setloading] = useState(false)

  const toast = useRef(null);

  const pageSize = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, patientData.length);
  const currentData = patientData.slice(startIndex, endIndex);

  const formatDate = (date) => {
    if (!date) return "";
    let newDate = new Date(date + "");
    let month = "" + (newDate.getMonth() + 1),
      day = "" + newDate.getDate(),
      year = newDate.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  };

  const showInfo = (message) => {
    toast.current.show({ severity: 'info', summary: 'Info', detail: message, life: 3000 });
  }

  const showError = (message) => {
    toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
  }
  const patientSearch = async () => {
        setloading(true);
  
    const requestBody = {
      ...(mobileNumber?.trim() && { mobile: mobileNumber.trim() }),
      ...(firstName?.trim() && { firstName: firstName.trim() }),
      ...(lastName?.trim() && { lastName: lastName.trim() }),
      ...(patientId?.trim() && { code: patientId.trim() }),
      ...(email?.trim() && { email: email.trim() }),
      ...(dob && { dob: formatDate(dob) })
    };
  
    try {
      const res = await notificationScreens.searchData(requestBody);
  
      console.log(res, "PATIENTDATA");
      setpatientData(res?.data?.successObject);
  
      if (res?.data?.successObject?.length > 0) {
        console.log(res?.data?.successObject?.length, "DataLength");
        setloading(false);
      } else if (res?.data?.successObject?.length === 0) {
        setloading(false);
        showInfo("No Data Found");
      }
    } catch (error) {
      console.error("Error searching patient:", error);
      setloading(false);
      showError("Something Went wrong");
    }
  };

  const patientFamilySearch = async (patientCode) => {

let payload ={
code : patientCode
}
  
    setloading(true);
  

    try {
      const res = await notificationScreens.searchFamilyData(payload); 
      setloading(false);
  
      console.log(res, "PATIENTDATA");
      setpatientData(res?.data?.successObject);
  
      if (res?.data?.successObject.length > 0) {
        console.log(res?.data?.successObject?.length, "DataLength");
      } else {
        toast.current.show({
          severity: 'info',
          summary: 'No Data',
          detail: 'No family members found',
          life: 3000
        });
      }
  
    } catch (error) {
      console.error("Error searching patient:", error);
      setloading(false);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Something went wrong',
        life: 3000
      });
    }
  };
  



  const onPageChange = (event, tabName) => {
    const newPage = event.page + 1;
    setCurrentPage(newPage);
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
  };

  const handlePatientItemKeyDown = (e, data) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSelectItem(data);
    }
  };

  const handleFamilySearchKeyDown = (e, patientCode) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      patientFamilySearch(patientCode);
    }
  };

  const handleOkayClick = () => {
    if (selectedItem) {
      onSelect({ code: selectedItem.code, name: selectedItem.salutation + selectedItem.firstName + selectedItem.lastName });
    }

    setSelectedItem(null);
    setmobileNumber("");
    setfirstName("");
    setlastName("");
    setpatientId("");
    setdob("");
    setemail("");
    setpatientData("");
    setshowBar(false);
  };

  const getPatientKey = (data, idx) => {
    return data?.code || `${data?.firstName}-${data?.lastName}-${data?.mobile}-${idx}`;
  };

  return (
    <Sidebar
      style={{ width: "50%" }} 
      dismissable={false}
      visible={showbar}
      position="right"
      className="overflow-y-auto"
      onHide={() => {
        setSelectedItem(null);
        setmobileNumber("");
        setfirstName("");
        setlastName("");
        setpatientId("");
        setdob("");
        setemail("");
        setpatientData("");
        setshowBar(false);
      }}
    >
      {loading && <Loader />}
      <Toast ref={toast} />
      <div className="p-4">
        <h2 className="text-lg font-bold text-[#262626] mb-4">Patient Search</h2>

        <div className="grid grid-cols-2 gap-4">
          <InputText value={patientId} placeholder="Patient ID" onChange={(e) => setpatientId(e.target.value)} className="w-full" />
          <InputText value={firstName} placeholder="First Name" onChange={(e) => setfirstName(e.target.value)} className="w-full" />
          <InputText value={lastName} placeholder="Last Name" onChange={(e) => setlastName(e.target.value)} className="w-full" />
          <InputText value={mobileNumber} placeholder="Mobile Number" onChange={(e) => setmobileNumber(e.target.value)} className="w-full" />
          <InputText value={email} placeholder="Email" onChange={(e) => setemail(e.target.value)} className="w-full" />
          <Calendar value={dob} placeholder="Date of Birth" onChange={(e) => setdob(e.value)} showIcon className="w-full" maxDate={new Date()} />
        </div>

        <div className="grid grid-cols-2 gap-4 mt-5">
          <Button label="Search" className="w-full border bg-[#004172] text-[#FFFFFF] rounded-md font-bold" onClick={patientSearch} />
        </div>

        {patientData.length > 0 && <h2 className="font-bold text-lg text-[#262626] mt-6">Check Patient Details</h2>}
        
        {currentData.length > 0 &&
          currentData.map((data, index) => (
              <button 
              key={getPatientKey(data, index)}
              type="button"
              className={`w-[90%] h-40 bg-[#FFFFFF] border border-[#E2E2E5] ml-14 mt-8 rounded-md cursor-pointer ${selectedItem === data ? "selected-item" : ""}`}
              onClick={() => handleSelectItem(data)}
              onKeyDown={(e) => handlePatientItemKeyDown(e, data)}
            >
              <div className="flex justify-between bg-gray-100 p-2">
                <h2 className="font-bold text-sm">
                  {(data?.salutation || '') + ' ' + (data?.firstName || '') + ' ' + (data?.lastName || '')}
                </h2>
                <h2 className="font-bold text-sm">{data?.code}</h2>
              </div>
              <div className="flex justify-between items-center px-2 pt-2">
                <div>
                  <p className="text-sm mt-2"><b>Gender:</b> {data?.gender}</p>
                  <p className="text-sm"><b>DOB:</b> {data?.dob}</p>
                  <p className="text-sm"><b>Mobile:</b> {data?.mobile}</p>
                </div>
                {data.status === 1 && (
                  <button
                    type="button"
                    className="w-[40%] border border-[#004172] text-[#004172] h-6 font-semibold rounded-md cursor-pointer"
                    onClick={() => patientFamilySearch(data?.code)}
                    onKeyDown={(e) => handleFamilySearchKeyDown(e, data?.code)}
                  >
                    Search Family Member
                  </button>
                )}
              </div>
            </button>
          ))}
        <Paginator
          first={(currentPage - 1) * pageSize}
          rows={pageSize}
          totalRecords={patientData.length}
          onPageChange={onPageChange}
          className="ml-32"
        />
        {patientData.length > 0 && (
          <button
            className="w-64 h-10 border border-[#004172] bg-[#004172] text-[#FFFFFF] first-letter:font-bold font-monospace rounded-md mt-16 ml-36"
            onClick={handleOkayClick}
          >
            Confirm
          </button>
        )}
      </div>
    </Sidebar>
  );
};

PatientSearch.propTypes = {
  showbar: PropTypes.bool.isRequired,
  setshowBar: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PatientSearch;